import { render } from "./deliveryDetail.vue?vue&type=template&id=9b2e58f0"
import script from "./deliveryDetail.vue?vue&type=script&lang=js"
export * from "./deliveryDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/marketing/deliveryDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b2e58f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b2e58f0', __exports__)) {
    console.log('reload')
    api.reload('9b2e58f0', __exports__)
  }
  
  module.hot.accept("./deliveryDetail.vue?vue&type=template&id=9b2e58f0", () => {
    console.log('re-render')
    api.rerender('9b2e58f0', render)
  })

}


export default __exports__